module.exports = __webpack_public_path__ + "static/media/choice.81338df0.mp3";